import React, {
  createContext,
  useContext,
  useMemo,
  useState,
  useEffect,
  useCallback,
} from "react";
import translations from "../i18n/translations";

const LocaleContext = createContext({
  lang: "mk",
  t: translations.mk,
  setLang: () => {},
});

const STORAGE_KEY = "anisija-lang";
const DEFAULT_LANG = "mk";

export const LocaleProvider = ({ initialLang, children }) => {
  const [lang, setLangState] = useState(() => {
    if (initialLang && translations[initialLang]) {
      return initialLang;
    }

    if (typeof window !== "undefined") {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored && translations[stored]) {
        return stored;
      }
    }

    return DEFAULT_LANG;
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, lang);
    }
  }, [lang]);

  const setLang = useCallback((code) => {
    if (translations[code]) {
      setLangState(code);
    }
  }, []);

  const value = useMemo(() => {
    const activeLang = translations[lang] ? lang : DEFAULT_LANG;
    return {
      lang: activeLang,
      t: translations[activeLang],
      setLang,
    };
  }, [lang, setLang]);

  return (
    <LocaleContext.Provider value={value}>
      {children}
    </LocaleContext.Provider>
  );
};

export const useLocale = () => useContext(LocaleContext);
